import { Record } from 'immutable';
import { schema } from 'normalizr';

export const RadioBilling = new Record({
  id: undefined,
  activation_state: undefined,
  billing_start_date: undefined,
  billed_site_group: undefined,
  data_plan: undefined,
  prepaid_coverages: undefined,
  radio: undefined,
  billing_end_date: undefined,
  full_warranty_end_date: undefined,
  partial_warranty_end_date: undefined,
  prepaid_follows_radio: undefined,
  warranty_start_date: undefined,
});

export const radioBillingSchema = new schema.Entity('radioBillings');

// for reading in nested models, object with { field: schema }
// radioBillingSchema.define({  });
